'use client';

import type { SupportedLanguage } from '@/app/types';
import { LANGUAGE_CONFIG } from '@/i18n/config';

export function getUsingLanguage(): SupportedLanguage {
  const pathSegments = typeof window !== 'undefined' ? window.location.pathname.split('/') : [];

  const languageFromUrl = pathSegments[1] || '';

  return LANGUAGE_CONFIG.supported.includes(languageFromUrl as SupportedLanguage)
    ? (languageFromUrl as SupportedLanguage)
    : LANGUAGE_CONFIG.default;
}
